export const moduleConfig = {
    entityKey: 'applicationProducts',
    titles: {
        singular: 'Application Product',
        plural: 'Application Products'
    }
}